import aframe from "aframe"

aframe.registerComponent("frame-box", {
    schema: {
        x: {
            type: "number"
        },

        y: {
            type: "number"
        },

    },

    init: function () {

        this.container = this.el.parentNode.parentNode

        this.container.setAttribute("rotation", {
            x: this.data.x,
            y: this.data.y,
        })

        this.el.addEventListener('clickDown', this.dragStart.bind(this))
        this.el.addEventListener('clickUp', this.dragEnd.bind(this))

    },

    remove: function () {

        this.el.removeEventListener('clickDown', this.dragStart.bind(this))
        this.el.removeEventListener('clickUp', this.dragEnd.bind(this))
    },

    dragStart: function() {

        this.container.setAttribute('fixed', {
            enabled: true,
            fixX: true,
            fixY: true,
        })

    },

    dragEnd: function() {
        
        if (!this.container.getAttribute('fixed')) return;
        if (!this.container.getAttribute('fixed').enabled) return;

        this.container.setAttribute('fixed', {
            enabled: false,
            fixX: true,
            fixY: true,
        })

        this.el.emit("dragEnd", {
            rotation: this.container.getAttribute('rotation')
        })
    }

})


// WEBPACK FOOTER //
// ./src/components-aframe/frameBox.js